function Footer() {
    return(
        <a 
            className='footer'
            href='https://drewford.dev'
            target='_blank'
        >
            <span>Developed by </span>
            <span>Drewford</span>
        </a>
    )
}

export default Footer